/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles } from '@material-ui/core';
import Button from 'components/Button';
import InputAdornmentChip from 'components/InputAdornmentChip';
import { Formik } from 'formik';
import i18n from 'i18n';
import { FormKeepingUserConnectedProps } from 'modules/environments/interfaces';
import React from 'react';
import GenericForm from 'skyone-lib/lib/GenericForm';
import schema from './schema';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface Props {
  emails?: string | undefined;
  onCancel: () => void;
  onSubmit: (values: FormKeepingUserConnectedProps) => void;
}

const initialValues: FormKeepingUserConnectedProps = {
  operator_name: '',
  notification_email: [],
};

const FormKeepingUserConnected = ({ onCancel, emails, onSubmit }: Props) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Grid
        container
        className={classes.container}
        data-testid={'autosky-formkeepinguserconnected'}
      >
        <Formik
          validationSchema={schema}
          initialValues={initialValues}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ setFieldValue, errors, values, submitForm }) => (
            <Grid container spacing={2}>
              <InputAdornmentChip
                gridXs={12}
                label="Email"
                stateKey="notification_email"
                values={emails?.split(',') || []}
                setFieldValue={setFieldValue}
              />
              <GenericForm
                fields={values}
                screenFields={[
                  {
                    gridXs: 12,
                    label: i18n.t('ENVIRONMENTS_PAGE.YOUR_NAME_KEY'),
                    stateKey: 'operator_name',
                  },
                ]}
                setFieldValue={setFieldValue}
                errors={errors}
              />
              <Grid
                container
                justify="flex-end"
                className={classes.buttons}
                style={{ margin: '8px 0 0' }}
              >
                <Button id="submit-button" onClick={submitForm} submitButton>
                  {i18n.t('ENVIRONMENTS_PAGE.PUBLICATIONS_KEY')}
                </Button>
                <Button
                  variant="outlined"
                  id="cancel-button"
                  onClick={onCancel}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            </Grid>
          )}
        </Formik>
      </Grid>
    </React.Fragment>
  );
};

export default FormKeepingUserConnected;
